import sanitizeHtml from 'sanitize-html';

document.querySelectorAll(".body-article blockquote").forEach(element => {
  let text = element.textContent;

  if (text.length > 100) {
    text = text.substring(0, 160) + "... ";
  }

  // Sanitizar y codificar la URL correctamente
  const url = encodeURIComponent(sanitizeHtml(window.location.href));
  
  // Sanitizar el texto para evitar XSS
  const sanitizedText = sanitizeHtml(text, {
    allowedTags: [],
    allowedAttributes: {}
  });

  // Crear elementos de forma segura en lugar de usar innerHTML
  const shareButton = document.createElement('a');
  shareButton.className = 'uc-share-quote-btn';
  
  if (window.current_locale === 'es') {
    const tweetText = encodeURIComponent(sanitizedText + ' ' + decodeURIComponent(url) + ' @ucatolica');
    shareButton.href = `https://twitter.com/intent/tweet?text=${tweetText}`;
    shareButton.textContent = 'Compartir';
  } else {
    const tweetText = encodeURIComponent(sanitizedText + ' ' + decodeURIComponent(url) + ' @ucatolica_chile');
    shareButton.href = `https://twitter.com/intent/tweet?text=${tweetText}`;
    shareButton.textContent = 'Share';
  }

  element.appendChild(shareButton);
});

document.querySelectorAll(".uc-alert_close").forEach(function (closeAlert) {
  closeAlert.style.cursor = "pointer";
  closeAlert.addEventListener('click', function (event) {
    // Verificar que el elemento padre existe antes de eliminarlo
    if (closeAlert.parentElement && closeAlert.parentElement.classList.contains('uc-alert')) {
      closeAlert.parentElement.remove();
    }
  });
});